import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestsService } from 'src/app/services/api/requests.service';
import { RequestCategoriesFormComponent } from '../../../components/request-categories-form/request-categories-form.component';

@Component({
  selector: 'app-request-categories-edit-page',
  imports: [RequestCategoriesFormComponent],
  templateUrl: './request-categories-edit-page.component.html',
  styleUrl: './request-categories-edit-page.component.scss'
})
export class RequestCategoriesEditPageComponent {
  requestCategoryId!: number
  requestCategory?: any;

  constructor(
    private route: ActivatedRoute,
    private requestsService: RequestsService,
  ) {
  }

  ngOnInit(): void {
    this.requestCategoryId = Number(this.route.snapshot.paramMap.get('requestCategoryId'));
    if (this.requestCategoryId) {
      this.loadData(this.requestCategoryId);
    }
  }

  loadData(requestCategoryId: any) {
    this.requestsService.detailSettingsRequestCategories(requestCategoryId).subscribe((response: any) => {
      this.requestCategory = response.data?.requestCategory;
    });

  }
}
